var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0544 6.00065L6.03227 10.0007M6.03227 6.00065L10.0544 10.0007M14.7468 8.00065C14.7468 11.6826 11.7455 14.6673 8.04331 14.6673C4.34109 14.6673 1.33984 11.6826 1.33984 8.00065C1.33984 4.31875 4.34109 1.33398 8.04331 1.33398C11.7455 1.33398 14.7468 4.31875 14.7468 8.00065Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateLogo);
export default __webpack_public_path__ + "static/media/Deactivate-logo.8abfefdff75876544c45eb6db6c7aca2.svg";
export { ForwardRef as ReactComponent };